import Flickity from 'flickity';
import { gsap } from '../global/gsap';

const initMenu = (toggle, onOpen) => {
    const body = document.querySelector('.js-body');
    const menu = document.querySelector('.js-menu');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'menu-open';
    let menuOpen = false;

    const timelines = document.querySelector('.js-menu-timelines');
    const content = document.querySelector('.js-menu-content');
    const track = document.querySelector('.js-menu-carousel');

    const menuTl = gsap.timeline({
        paused: true,
        defaults: {
            overwrite: 'all',
            ease: 'power3.out',
            duration: 0.5
        },
        onStart: () => {
            menu.classList.remove('menu-animated');
        },
        onComplete: () => {
            menu.classList.add('menu-animated');
        }
    });

    menuTl.fromTo([content, timelines], {
        x: '100%',
        opacity: 0
    }, {
        x: 0,
        opacity: 1,
        stagger: 0.15
    });

    const close = () => {
        menuOpen = false;
        body.classList.remove(stopScrollingClass, isActiveClass);
        menuTl.reverse();
    };

    document.addEventListener('click', (event) => {
        if (menuOpen && event.target === menu) {
            close();
        }

        if (event.target === toggle) {
            event.preventDefault();
            menuOpen = !menuOpen;

            if (menuOpen) {
                if (onOpen) { onOpen(); }
                // Force play from start of TL each time
                menuTl.play(0);
                body.classList.add(stopScrollingClass, isActiveClass);
            } else {
                close();
            }
        }
    });

    const flickityOptions = {
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        watchCSS: true
    };

    const carousel = new Flickity(track, flickityOptions);

    // Disable click events on drag
    carousel.on('dragStart', () => {
        carousel.slider.style.pointerEvents = 'none';
    });

    carousel.on('dragEnd', () => {
        carousel.slider.style.pointerEvents = 'auto';
    });

    // Return close function to be used by initSearch
    return { close };
};

export { initMenu as default };
